import { RootState } from 'src/types/RootState';

export function getFeedbackModal(state: RootState): boolean {
  return state.feedback.feedbackModalOpened;
}
